import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = {
  key: 1,
  class: "flex gap-x-4 w-full justify-end pl-2 pr-6"
}
const _hoisted_3 = {
  id: "searchOverlay",
  class: "flex gap-2 w-full"
}
const _hoisted_4 = { class: "flex flex-col overflow-auto w-full top-36" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "py-6 border-0 px-4"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-gray-800 font-medium" }
const _hoisted_10 = { class: "col-span-2 flex" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex gap-x-4" }
const _hoisted_16 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_17 = { class: "flex-1" }
const _hoisted_18 = { class: "overflow-hidden" }

import { ref, computed, onMounted, watch, nextTick } from "vue"
import GgmsNavigation from "@/components/GgmsNavigation.vue"
import GgmsTaskSessionBar from "@/components/GgmsTaskSessionBar.vue"
import AddContactModal from "@/components/AddContactModal.vue"
import EmailVerificationModal from "@/components/email-verification/EmailVerificationModal.vue"
import PhoneCallSidebar from "@/components/phone-sidebar/PhoneCallSidebar.vue"
import PhoneOnCallBar from "@/components/phone-sidebar/PhoneOnCallBar.vue"
import NotificationSidebar from "@/components/notifications/NotificationsSidebar.vue"
import MobileSidebarAndHeader from "@/components/MobileSidebarAndheader.vue"
import MenuActionItems from "@/components/MenuActionItems.vue"
import FilterSidebar from "@/components/filters/FilterSidebar.vue"
import CreateTask from "@/components/tasks/CreateTask.vue"
import { ArrowLeftIcon, ArrowRightIcon, InformationCircleIcon } from "@heroicons/vue/outline"

import {
    UsersIcon,
    InboxInIcon,
    ClipboardCheckIcon,
    CogIcon,
    DocumentTextIcon,
    PresentationChartLineIcon,
    ClipboardListIcon,
    RefreshIcon,
    FireIcon,
    SpeakerphoneIcon,
    SearchIcon,
    HomeIcon,
} from "@heroicons/vue/outline"
import CodeSquareIcon from "@/components/icons/CodeSquareIcon.vue"

import {
    getUser,
    deleteCookie,
    getCookieValue,
    hasUserPermission,
    debounce,
    internationalPhoneFormat,
    hasUserOnlyReadPermission,
} from "@/shared/utils/helpers"
import { useTaskStore } from "@/stores/task"
import { useTagStore } from "@/stores/tag"
import { useAuthStore } from "@/stores/auth"
import { useAgencyStore } from "@/stores/agency"
import { usePhoneCallStore } from "@/stores/phone-call"
import { useConfigStore } from "@/stores/config"
import { useAgentsStore } from "@/stores/agents"
import { useSocketStore } from "@/stores/socket"
import { useContactsStore } from "@/stores/contacts"
import { useOriginStore } from "@/stores/origin"
import { useLifecycleStageStore } from "@/stores/lifecycle-stage"
import { useContactRoleStore } from "@/stores/contact-role"
import { useSalesStatusStore } from "@/stores/sales-status"
import { PhoneCall } from "@/shared/models/phone-call"
import { ResourceTypeName, Role } from "@/shared/models/role"
import { AuthUserRole } from "@/shared/models/user"
import { Contact } from "@/shared/models/contact"
import router from "@/router"
import CreatingMessage from "@/components/profile-details/middle-panel/CreatingMessage.vue"
import CreatingEmail from "@/components/profile-details/middle-panel/CreatingEmail.vue"
import GgmsModal from "@/components/GgmsModal.vue"
import GgmsTooltip from "@/components/GgmsTooltip.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import EmailStatus from "@/components/profile-details/left-panel/EmailStatus.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'GgmsSidebarAndHeader',
  setup(__props) {

const taskStore = useTaskStore()
const tagStore = useTagStore()
const authStore = useAuthStore()
const agencyStore = useAgencyStore()
const phoneCallStore = usePhoneCallStore()
const configStore = useConfigStore()
const agentsStore = useAgentsStore()
const socketStore = useSocketStore()
const contactStore = useContactsStore()
const originStore = useOriginStore()
const lifecycleStageStore = useLifecycleStageStore()
const contactRoleStore = useContactRoleStore()
const salesStatusStore = useSalesStatusStore()

let navigation = [
    // { name: "Dashboard", icon: HomeIcon, path: "/dashboard" },
    { name: "Contacts", icon: UsersIcon, path: "/contacts" },
    { name: "Listings", icon: HomeIcon, path: "/listings" },
    { name: "Inbox", icon: InboxInIcon, path: "/inbox" },
    // { name: "Deals", icon: TagIcon, path: "/deals" },
    { name: "Tasks", icon: ClipboardCheckIcon, path: "/tasks" },
    // { name: "Reports", icon: ChartBarIcon, path: "/reports" },
    {
        name: "Templates",
        icon: DocumentTextIcon,
        path: "/templates",
    },
    {
        name: "Workflows",
        icon: FireIcon,
        path: "/workflows",
    },
    { name: "Forms", icon: ClipboardListIcon, path: "/forms" },
    {
        name: "Marketing",
        icon: SpeakerphoneIcon,
        children: [
            { name: "Tracking", path: "/marketing-campaigns" },
            {
                name: "Areas",
                path: "/areas",
            },
        ],
    },
    {
        name: "Developers",
        icon: CodeSquareIcon,
        children: [
            {
                name: "Beacon Code",
                path: "/developers/beacon-code",
            },
            {
                name: "API Keys",
                path: "/developers/api-keys",
            },
            {
                name: "Beacon Events",
                path: "/developers/track-events",
            },
        ],
    },
    {
        name: "Settings",
        icon: CogIcon,
        children: [
            {
                name: "My Settings",
                path: "/my-settings",
            },
            {
                name: "Agency Settings",
                path: "/agency-settings",
            },
            {
                name: "Plans & Billing",
                path: "/billing",
            },
            {
                name: "Agencies",
                path: "/agencies",
            },
            {
                name: "MLS Feeds",
                path: "/mls-feeds",
            },
            {
                name: "Domains",
                path: "/domains",
            },
            {
                name: "Fields",
                path: "/fields",
            },
            {
                name: "Phone Numbers",
                path: "/phone-numbers",
            },
            {
                name: "Tags",
                path: "/tags",
            },
            {
                name: "Origins",
                path: "/origins",
            },
            {
                name: "Collections",
                path: "/collections",
            },
            {
                name: "Agency Theme",
                path: "/themes",
            },
            {
                name: "Integrations",
                path: "/integrations",
            },
            {
                name: "Area Groups",
                path: "/area-groups",
            },
        ],
    },
    { name: "Team", icon: UsersIcon, path: "/team" },
    // { name: "Audit", icon: PresentationChartLineIcon, path: "/audit" },
    { name: "Event Logs", icon: PresentationChartLineIcon, path: "/logs" },
    { name: "Jobs", icon: RefreshIcon, path: "/jobs" },
]

// Collapse/Expand sidebar
const isCollapsed = ref(window.screen.width <= 1728)
const ArrowIcon = computed(() => (isCollapsed.value ? ArrowRightIcon : ArrowLeftIcon))

const isDataFetched = ref(false)
const isPhoneSidebarOpen = computed<boolean>({
    get: () => phoneCallStore.isSidebarOpen,
    set: (v) => (phoneCallStore.isSidebarOpen = v),
})
const isNotificationSidebarOpen = ref(false)
const isAgencyNewlyRegistered = ref(false)
const searchTerm = ref("")

//--------create task------------------
const isCreateTaskModalOpen = ref(false)

//--------send email------------------
const isNewEmailModalOpen = ref(false)
const currentEmail = ref()

//--------send text message------------------
const isNewMessageModalOpen = ref(false)
const currentMessage = ref()

//--------search menu------------------
const search = ref()
const isSearching = ref(false)
const contacts = ref<Contact[]>([])
const totalContacts = ref(0)

//--------create task------------------
const taskId = ref("")
const modalAction = ref("")

const isPhoneCallInProgress = computed(() => ["calling", "ongoing"].includes(phoneCallStore.phoneCallState))
const isPhoneTopBarVisible = computed(() => isPhoneCallInProgress.value && !phoneCallStore.isSidebarOpen)
const mainTopBarTopClass = computed(() => (isPhoneTopBarVisible.value ? "top-[66px]" : "top-0"))
const isAddContactModalOpen = computed(() => contactStore.isAddContactModalOpen)
const phoneCallContact = computed(() => phoneCallStore.currentPhoneCall?.contacts?.[0])
const currentUser = computed(() => authStore.currentUser)
const isTaskSessionStarted = computed(() => taskStore.isActiveTaskSession)

const isTestMode = computed(() => agencyStore.agency?.isTestMode)

const isMobileScreen = computed(() => window.screen.width < 768)

const isNotEditableByUser = computed(() => hasUserOnlyReadPermission("Tasks"))

function onTaskModifying(): void {
    closeCreateTaskModal()
    if (router.currentRoute.value.path === "/tasks") {
        taskStore.getTasks()
    }
}

function setCreateTaskModalVisibility(isOpen: boolean): void {
    isCreateTaskModalOpen.value = isOpen
}

// Toggle sidebar collapse/expand
function toggleSidebar() {
    isCollapsed.value = !isCollapsed.value
}

// Handle menu item click
function handleMenuClick(menuItem: any) {
    const currentRoute = router.currentRoute.value.path
    const isSubpage = menuItem.children?.some((child: { name: string; path: string }) => child.path === currentRoute)

    if (isSubpage) {
        isCollapsed.value = false

        return
    }

    if (menuItem.name === "Settings" || menuItem.name === "Developers" || menuItem.name === "Marketing") {
        isCollapsed.value = false

        nextTick(() => {
            const menuItemElement = document.getElementsByName(menuItem.name)[0]
            if (menuItemElement) {
                menuItemElement.click()
            }
        })
    }
}

function redirectToCompanySettings() {
    router.push("/agency-settings")
}

async function openAddContactModal() {
    tagStore.tableState.typeName = "contact"
    await originStore.getAllOrigins()
    contactStore.isAddContactModalOpen = true
}

function openCreateTaskModal() {
    taskId.value = ""
    modalAction.value = "create"
    isCreateTaskModalOpen.value = true
}

function closeCreateTaskModal() {
    isCreateTaskModalOpen.value = false
}

function closeAddContactModal() {
    contactStore.isAddContactModalOpen = false
    phoneCallStore.currentPhoneCall = {} as Partial<PhoneCall>
}

function openPhoneSidebar() {
    if (contactStore.tableState.selectedData?.length) {
        phoneCallStore.selectedContact = contactStore.tableState.selectedData[0]
    }
    phoneCallStore.openSidebar()
}

function closeCall() {
    phoneCallStore.phoneCallState = "finished"
    phoneCallStore.disconnectTwilio()
}

function openNotificationSidebar() {
    isNotificationSidebarOpen.value = true
}

function closeEmailVerificationModal() {
    isAgencyNewlyRegistered.value = false
    deleteCookie("isAgencyNewlyRegistered")
}

function checkIfAgencyIsNewlyRegistered() {
    const isAgencyNewlyRegisteredCookie = getCookieValue("isAgencyNewlyRegistered")

    // if the email is confirmed, emailConfirmation will be undefined and we explicitly check the value for false
    isAgencyNewlyRegistered.value =
        currentUser.value?.emailConfirmation?.confirmed === false && isAgencyNewlyRegisteredCookie === "true"
}

function closeNewMessageModal() {
    isNewMessageModalOpen.value = false
}

function closeCreateEmailModal() {
    isNewEmailModalOpen.value = false
}

function openNewMessageModal() {
    isNewMessageModalOpen.value = true
}

function openNewEmailModal() {
    isNewEmailModalOpen.value = true
}

function toggleSearch(event?: Event) {
    search.value.show(event)
}

function navigateToContacts(id?: string) {
    router.push(id ? `/contacts/${id}` : "/contacts")
    searchTerm.value = ""
    contacts.value = []
    search.value.hide()
}

onMounted(async () => {
    await Promise.all([
        agencyStore.loadAgency(),
        agencyStore.getAvailableAgencies(),
        taskStore.getActiveTaskSession(),
        configStore.getConfig(),
        agentsStore.getMe(),
        tagStore.getCachedTags(),
        originStore.getCachedOrigins(),
        lifecycleStageStore.getCachedLifecycleStages(),
        contactRoleStore.getCachedRoles(),
        salesStatusStore.getCachedSalesStatuses(),
        socketStore.connectSocket(),
        socketStore.connectJobs(),
        agentsStore.loadAgents(),
    ])
    const user = getUser()
    authStore.currentUser = user
    isDataFetched.value = true
    // filter out those navigation items that doesn't have permission
    const isMember = user?.role?.name === AuthUserRole.member
    if (isMember) {
        navigation = navigation.filter((item) => {
            // Hide entire Marketing and Developers sections
            if (["Marketing", "Developers"].includes(item.name)) return false
            // Hide Team
            if (item.name === "Team") return false
            // Hide Settings subitems for Member
            if (item.name === "Settings") {
                if (item.children) {
                    item.children = item.children.filter(
                        (child) =>
                            ![
                                "Agency Settings",
                                "Plans & Billing",
                                "Agencies",
                                "MLS Feeds",
                                "Domains",
                                "Fields",
                                "Phone Numbers",
                                "Origins",
                                "Agency Theme",
                                "Integrations",
                                "Area Groups",
                            ].includes(child.name)
                    )
                    // If no children left, hide Settings
                    return item.children.length > 0
                }
                return false
            }
            return true
        })
    }
    navigation = navigation.filter((item) => hasUserPermission(user?.role as Role, item.name as ResourceTypeName))
    checkIfAgencyIsNewlyRegistered()

    // Set up a periodic check for socket connection
    setInterval(() => {
        if (!socketStore.isConnected) {
            console.log("Socket disconnected, attempting to reconnect...")
            socketStore.reconnectSocket()
        }
    }, 30000) // Check every 30 seconds
})

// Add route change handler to ensure socket is connected when navigating
watch(
    () => router.currentRoute.value.path,
    () => {
        if (!socketStore.isConnected) {
            console.log("Reconnecting socket on route change...")
            socketStore.reconnectSocket()
        }
    }
)

watch(
    () => contactStore.isAddContactModalOpen,
    (value) => {
        if (!value) {
            return
        }
        isPhoneSidebarOpen.value = false
        phoneCallStore.phoneCallState = "idle"
        isNotificationSidebarOpen.value = false
    }
)

watch(
    () => searchTerm.value,
    debounce(async () => {
        if (searchTerm.value.trim() === "") {
            contacts.value = []
            if (searchTerm.value === "") {
                search.value.hide()
            }
            return
        }
        isSearching.value = true
        contacts.value = await contactStore.getContacts(searchTerm.value)
        totalContacts.value = contacts.value.length
        if (contacts.value.length > 8) contacts.value = contacts.value.slice(0, 8)
        isSearching.value = false
    }, 250)
)

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (isDataFetched.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (isPhoneTopBarVisible.value)
          ? (_openBlock(), _createBlock(PhoneOnCallBar, {
              key: 0,
              onOnCloseCall: closeCall,
              onOnOpenSidebar: openPhoneSidebar
            }))
          : _createCommentVNode("", true),
        (isTaskSessionStarted.value)
          ? (_openBlock(), _createBlock(GgmsTaskSessionBar, { key: 1 }))
          : _createCommentVNode("", true),
        (!isMobileScreen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([
                'flex flex-col fixed h-full transition-all duration-500 ease-in-out',
                isCollapsed.value ? 'w-16' : 'w-56',
            ]),
              style: {"z-index":"40"}
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(GgmsNavigation, {
                  items: _unref(navigation),
                  collapsed: isCollapsed.value,
                  onMenuItemClick: handleMenuClick
                }, null, 8, ["items", "collapsed"]),
                _createElementVNode("div", {
                  onClick: toggleSidebar,
                  class: _normalizeClass(["w-6 h-6 bg-white border rounded-full flex justify-center items-center cursor-pointer transition-transform duration-300 ease-in-out hover:bg-primary-color-600 hover:text-white focus:ring focus:ring-primary-color absolute bottom-36 -right-3 group", { 'rotate-180': isCollapsed.value }]),
                  role: "button",
                  "aria-label": "Collapse Sidebar"
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(ArrowIcon.value), {
                    class: _normalizeClass(["w-4 h-4 text-primary-color-600 transition-transform duration-300 ease-in-out group-hover:text-white", { 'transform rotate-180': isCollapsed.value }])
                  }, null, 8, ["class"]))
                ], 2)
              ])
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass([
                isCollapsed.value ? 'md:pl-16' : isMobileScreen.value ? '' : 'md:pl-56',
                'flex flex-col flex-1 transition-all duration-300 ease-in-out z-50',
            ])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["sticky z-40 flex-shrink-0 flex h-fit bg-white shadow", mainTopBarTopClass.value])
          }, [
            (isMobileScreen.value)
              ? (_openBlock(), _createBlock(MobileSidebarAndHeader, {
                  key: 0,
                  navigation: _unref(navigation),
                  isTestMode: isTestMode.value,
                  onOpenPhoneSidebar: openPhoneSidebar,
                  onOpenAddContactModal: openAddContactModal,
                  onOpenNotificationSidebar: openNotificationSidebar
                }, null, 8, ["navigation", "isTestMode"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(GgmsInput, {
                      modelValue: searchTerm.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
                      placeholder: "Search",
                      iconStart: _unref(SearchIcon),
                      inputClass: "border-0 shadow-transparent h-16 focus:ring-0 focus:border-0",
                      class: "w-full",
                      onInput: toggleSearch
                    }, null, 8, ["modelValue", "iconStart"]),
                    _createVNode(_component_OverlayPanel, {
                      ref_key: "search",
                      ref: search,
                      class: _normalizeClass([
                                isTestMode.value ? 'mr-96' : 'mr-80',
                                '!left-0 ring-1 ring-black ring-opacity-5 shadow-lg rounded-md ml-4  bg-white right-1',
                            ]),
                      appendTo: "#searchOverlay"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            (!contacts.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No results found"))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts.value, (contact) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: contact._id,
                                      class: "py-3 grid grid-cols-4 cursor-pointer text-sm leading-5 font-normal text-gray-700 hover:bg-gray-50 px-4",
                                      onClick: ($event: any) => (navigateToContacts(contact._id))
                                    }, [
                                      _createElementVNode("span", _hoisted_9, _toDisplayString(contact.firstName) + " " + _toDisplayString(contact.lastName), 1),
                                      _createElementVNode("div", _hoisted_10, [
                                        (contact.emails?.length)
                                          ? (_openBlock(), _createBlock(EmailStatus, {
                                              key: 0,
                                              email: contact.emails.find((email) => email.isPrimary)!,
                                              class: "mr-2"
                                            }, null, 8, ["email"]))
                                          : _createCommentVNode("", true),
                                        (contact.emails?.length)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(contact.emails.find((email) => email.isPrimary)
                                                        ?.emailAddress), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_12))
                                      ]),
                                      (contact.phones?.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(internationalPhoneFormat)(contact?.phones[0].number)), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_14))
                                    ], 8, _hoisted_8))
                                  }), 128)),
                                  (totalContacts.value > contacts.value.length)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "cursor-pointer text-sm leading-5 font-medium text-gray-800 py-3 px-4",
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateToContacts()))
                                      }, " View all " + _toDisplayString(totalContacts.value), 1))
                                    : _createCommentVNode("", true)
                                ])),
                            (isSearching.value)
                              ? (_openBlock(), _createBlock(GgmsLoading, { key: 2 }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (isTestMode.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(GgmsTooltip, {
                            text: "The system is in Test Mode. Communications are restricted until going live.",
                            icon: _unref(InformationCircleIcon),
                            iconClass: "w-8 h-8 cursor-pointer",
                            iconColorClass: "text-orange-300 hover:text-orange-500",
                            onOnButtonClick: redirectToCompanySettings
                          }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(MenuActionItems, {
                      class: "h-16",
                      onOpenCreateTaskModal: openCreateTaskModal,
                      onOpenPhoneSidebar: openPhoneSidebar,
                      onOpenAddContactModal: openAddContactModal,
                      onOpenNotificationSidebar: openNotificationSidebar,
                      onOpenNewEmail: openNewEmailModal,
                      onOpenNewMessage: openNewMessageModal
                    })
                  ])
                ]))
          ], 2),
          _createElementVNode("main", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ])
        ], 2),
        _createVNode(AddContactModal, {
          open: isAddContactModalOpen.value,
          contact: phoneCallContact.value,
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (closeAddContactModal()))
        }, null, 8, ["open", "contact"]),
        _createVNode(GgmsModal, {
          open: isNewMessageModalOpen.value,
          bodyClass: "p-0",
          headerClass: "border-b border-gray-200 py-5",
          size: "3xl",
          onCloseModal: closeNewMessageModal
        }, {
          header: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("div", null, "New Message", -1)
          ])),
          default: _withCtx(() => [
            _createVNode(CreatingMessage, {
              textMessage: currentMessage.value,
              hasContact: true,
              onSaveTextMessage: closeNewMessageModal
            }, null, 8, ["textMessage"])
          ]),
          _: 1
        }, 8, ["open"]),
        _createVNode(GgmsModal, {
          open: isNewEmailModalOpen.value,
          bodyClass: "p-0",
          headerClass: "border-b border-gray-200 py-5",
          size: "3xl",
          onCloseModal: closeCreateEmailModal
        }, {
          header: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("h1", { class: "text-lg font-medium text-gray-900" }, "New Email", -1)
          ])),
          default: _withCtx(() => [
            _createVNode(CreatingEmail, {
              message: currentEmail.value,
              hasContact: true,
              onSaveEmail: closeCreateEmailModal
            }, null, 8, ["message"])
          ]),
          _: 1
        }, 8, ["open"]),
        _createVNode(PhoneCallSidebar, {
          modelValue: isPhoneSidebarOpen.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isPhoneSidebarOpen).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(NotificationSidebar, {
          modelValue: isNotificationSidebarOpen.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isNotificationSidebarOpen).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(FilterSidebar),
        _createVNode(EmailVerificationModal, {
          open: isAgencyNewlyRegistered.value,
          onCloseModal: closeEmailVerificationModal
        }, null, 8, ["open"]),
        _createVNode(CreateTask, {
          taskId: taskId.value,
          isCreateTaskModalOpen: isCreateTaskModalOpen.value,
          modalAction: modalAction.value,
          isNotEditableByUser: isNotEditableByUser.value,
          onOnCreateTask: onTaskModifying,
          onOnCreateTaskModalClose: setCreateTaskModalVisibility
        }, null, 8, ["taskId", "isCreateTaskModalOpen", "modalAction", "isNotEditableByUser"])
      ], 64))
    : _createCommentVNode("", true)
}
}

})